export const fullPageLoader = () => ({
  backgroundColor: `#fff`,
})
